<template>
    <!--================ Hero sm Banner start =================-->      
  <section class="hero-banner hero-banner--sm mb-30px" style="height:300px;">
    <div class="container">
      <div class="hero-banner--sm__content">
        <h1>{{ this.$route.name }}</h1>
        <nav aria-label="breadcrumb" class="banner-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ this.$route.name }}</li>
          </ol>
        </nav>
      </div>
    </div>
  </section>
  <!--================ Hero sm Banner end =================-->
</template>

<script>
export default {

}
</script>

<style>

</style>